import { render, staticRenderFns } from "./summary-object-details.vue?vue&type=template&id=180aa92c&"
import script from "./summary-object-details.vue?vue&type=script&lang=js&"
export * from "./summary-object-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./summary-object-details-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcommon%2Fsummary%2Fregistration%2Fsummary-object-details.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports